import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab, TextField, Button, CardMedia, Input, MenuItem, Select, SelectChangeEvent, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React, { ChangeEvent, useState } from "react";
import AddIcon from '@mui/icons-material/Add';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddCustomer = () => {

  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [selectField1, setSelectField1] = React.useState('default');
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const handleNextTab = () => {
    setValueTabs((prevIndex) => prevIndex + 1); // Move to the next tab
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Add Customer</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-customers")}>Manage Customers</span>
          {' '} - Add Customer
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Personal Details" {...a11yProps(0)} />
              <Tab label="Property Details" {...a11yProps(1)} />
              <Tab label="Passport" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Upload Image</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={image}
                          alt="photo"
                        />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(
                        event: ChangeEvent<HTMLInputElement>
                      ) => {
                        const files = (
                          event.target as HTMLInputElement
                        ).files;
                        if (
                          files &&
                          files[0].type.includes("image")
                        ) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage(
                            "This field only accepts images."
                          );
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="icon"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group w_50">
                <label>Name</label>
                <TextField placeholder="Enter Name" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_50">
                <label>Email Id</label>
                <TextField placeholder="Enter Email Id" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <TextField placeholder="Enter Phone Number" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_50">
                <label>Address</label>
                <TextField placeholder="Enter Address" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>City</label>
                <TextField placeholder="Enter City" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>State</label>
                <TextField placeholder="Enter State" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>Country</label>
                <TextField placeholder="Enter Country" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>Zip Code</label>
                <TextField placeholder="Enter State" hiddenLabel fullWidth></TextField>
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={handleNextTab}>Next</Button>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="form">
            <div className="borderBox">
              <IconButton className="remove_icon"><CloseIcon /></IconButton>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Property Name</label>
                  <TextField placeholder="Enter Property Name" hiddenLabel fullWidth></TextField>
                </div>
                <div className="control_group w_50">
                  <label>Property</label>
                  <Select
                    fullWidth
                    labelId="country_to"
                    id="country_to"
                    value={selectField1}
                    onChange={handleChange1}
                  >
                    <MenuItem disabled value="default">Select Property</MenuItem>
                    <MenuItem value={10}>Home</MenuItem>
                    <MenuItem value={20}>Villa</MenuItem>
                    <MenuItem value={30}>Apartment</MenuItem>
                    <MenuItem value={40}>Building</MenuItem>
                  </Select>
                </div>
                <div className="control_group w_50">
                  <label>Address</label>
                  <TextField placeholder="Enter Address" hiddenLabel fullWidth></TextField>
                </div>
                <div className="control_group w_50">
                  <label>City</label>
                  <TextField placeholder="Enter City" hiddenLabel fullWidth></TextField>
                </div>
              </div>
            </div>
            <div className="borderBox">
              <IconButton className="remove_icon"><CloseIcon /></IconButton>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Property Name</label>
                  <TextField placeholder="Enter Property Name" hiddenLabel fullWidth></TextField>
                </div>
                <div className="control_group w_50">
                  <label>Property</label>
                  <Select
                    fullWidth
                    labelId="country_to"
                    id="country_to"
                    value={selectField1}
                    onChange={handleChange1}
                  >
                    <MenuItem disabled value="default">Select Property</MenuItem>
                    <MenuItem value={10}>Home</MenuItem>
                    <MenuItem value={20}>Villa</MenuItem>
                    <MenuItem value={30}>Apartment</MenuItem>
                    <MenuItem value={40}>Building</MenuItem>
                  </Select>
                </div>
                <div className="control_group w_50">
                  <label>Address</label>
                  <TextField placeholder="Enter Address" hiddenLabel fullWidth></TextField>
                </div>
                <div className="control_group w_50">
                  <label>City</label>
                  <TextField placeholder="Enter City" hiddenLabel fullWidth></TextField>
                </div>
              </div>
            </div>
            <p className="link_text end"><span className="c_primary"><AddIcon /> Add more properties</span></p>
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={handleNextTab}>Next</Button>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Expiry Date</label>
                <TextField placeholder="Enter Expiry Date" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_33">
                <label>Upload Front Image</label>
                {image ? (
                  <div className="upload_image no_radius v2">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={image}
                          alt="photo"
                        />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius v2"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(
                        event: ChangeEvent<HTMLInputElement>
                      ) => {
                        const files = (
                          event.target as HTMLInputElement
                        ).files;
                        if (
                          files &&
                          files[0].type.includes("image")
                        ) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage(
                            "This field only accepts images."
                          );
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="icon"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group w_33">
                <label>Upload Back Image</label>
                {image ? (
                  <div className="upload_image no_radius v2">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={image}
                          alt="photo"
                        />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius v2"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(
                        event: ChangeEvent<HTMLInputElement>
                      ) => {
                        const files = (
                          event.target as HTMLInputElement
                        ).files;
                        if (
                          files &&
                          files[0].type.includes("image")
                        ) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage(
                            "This field only accepts images."
                          );
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="icon"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={() => navigate("/manage-customers")}>Save</Button>
            </div>
          </div>
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default AddCustomer;
